import * as bookingsServices from './bookingsServices';

export { bookingsServices };
